import {jwtDecode} from "jwt-decode";

export default function decodeToken(token) {
  return jwtDecode(token, { complete: true });
}
